module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-04-30d6053f9124d2c193b6b2928474d866.jpg";